import { actionTypes } from "./actions";

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.APP_SUPPORT_POST_SUCCESS:
        default: {
            return state;
        }
    }
}
